<script setup lang="ts">
import type { NuxtError } from '#app'

useSeoMeta({
  title: 'Page not found',
  description: 'We are sorry but this page could not be found.'
})

const props = defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    required: true
  }
})

useHead({
  htmlAttrs: {
    lang: 'en'
  },
  title: 'Error',
})

</script>

<template>
  <div>
    <UError
      :error="error"
      redirect="/"
      :clear="{
              label: 'Intentar de nuevo',
              color: 'secondary'
            }"
      :ui="{
              statusCode: 'hidden'
            }"
    />
  </div>
</template>
